
// Definición de defaults

export const defaultDistritoJudicial: DistritoJudicialProps = {
    idDistritoJudicial: 0,
    descripcion:        '',
    activo:             false,
}

// Creación de interfaces

export interface DistritoJudicialProps{

    idDistritoJudicial:         number;
    descripcion:                string;
    activo:                     boolean;
}